// React imports.
import React, { Component } from "react";

// App imports.
import Assessment1MainTable from "./Assessment1MainTable";
import Assessment1TopParagraph from "./Assessment1TopParagraph";
import Assessment1Questions from "./Assessment1Questions";
import Assessment1DownloadCSV from "./Assessment1DownloadCSV";
import TableLegendLeft from "./TableLegendLeft";

import { Assessment1StepsEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";


const Assessment1 = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.EnterDataAverageExpenditures &&
          <div>
                  <p><strong><u>Step 1:</u>Enter Data</strong></p>
                  Assessment 1 is designed to help you take the average expenditures for
                  each fuel type from your data and compare it to reasonable estimates of
                  low-income main heating expenditures in your state.
                  <br/><br/>
                  If the data for the year you are trying to evaluate is available
                  in the Data Warehouse, it will be auto-populated below. If this
                  is the case, please verify that they are correct before clicking next.
                  <br/><br/>
                  If you are trying to evaluate a year for which data has not yet
                  been added to the Data Warehouse, you will need to manually
                  enter the <strong>Calculated Average Expenditures</strong> which can be found
                  in <strong>Section V, Part B, Line 4 of your Performance Data Form</strong>.
                  <br/><br/>
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]} state={state} />
                  <TableLegendLeft />
                  <br />
                  {state.Assessment1FuelTypesStatus.Electric.computedAverageExpenditure === null
                    &&<span className="errorMessageText" >
                          Performance Measures data for Fiscal Year &nbsp;{state.SelectedYear}&nbsp;is not yet
                          available in the LIHEAP Data Warehouse. Please provide this information from Section
                          V, Part B, Line 4 of your Performance Data Form.
                      </span>
                  }
                  

              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.DisplaySeds &&
              <div>
                  <p><strong><u>Step 2:</u> Reviewing SEDS data for your state</strong></p>
                  The EIA's State Energy Data System (SEDS) is a comprehensive data set that 
                  consists of annual time series estimates of state-level energy expenditure data. 
                  <br/><br/>
                  The raw SEDS averages incorporate expenditures from all consumers in a state 
                  regardless of socioeconomic status. To account for this, APPRISE has applied 
                  a modification methodology so that the data only reflect estimates for the 
                  portion of your state’s population that are LIHEAP eligible.
                  <br/><br/>
                  The average main heating expenditures from the modified SEDS data for 
                  &nbsp;{state.SelectedYear}&nbsp;are listed in the table below.  If the table
                  reads “No SEDS Data” instead of an expenditure value for one of your fuel types,
                  this means that less than 1% of the low-income households in your state use that
                  fuel to heat their home. Because it is not meaningful to check the data
                  reliability for fuel types that cover such a small proportion of your
                  total households, fuel types that are listed as “No SEDS Data” will
                  not be evaluated for the remainder of the assessment.
                  <br/><br/>

                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.PercentOfSeds &&
              <div>
                  <p><strong><u>Step 3:</u>Your data as a percentage of the SEDS estimates</strong>
                  </p>
                  <p>
                      Your low-income average main heating expenditure data should typically fall
                      in the range of the baseload expenditure data found within the SEDS.
                  </p>
                  <p>
                      This assessment flags when your computed average main heating expenditure data
                      is less than 50% of your state's SEDS average value or more than 150%
                      of your state's SEDS average value.
                  </p>
                  <p>
                      If your average main heating energy expenditure data does not fall within these
                      thresholds, vendors may not be including the correct expenditures in their reports
                      or they may not be reporting for the correct amount of time.
                  </p>
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <br />
              </div> 
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.ElectricFollowup &&
              <div>
                  <p>
                      <strong><u>Step 3a:</u>Results - Electric Heat Households</strong>
                  </p>
                  
                  <Assessment1TopParagraph state={state} fuelType={state.Assessment1FuelTypesStatus.Electric} />
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  
                  <Assessment1Questions state={state}  fuelType={state.Assessment1FuelTypesStatus.Electric} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.NaturalGasFollowup &&
              <div>
                  <p>
                      <strong><u>Step 3b:</u>Results - Natural Gas Households</strong>
                  </p>
                  
                  <Assessment1TopParagraph state={state}  fuelType={state.Assessment1FuelTypesStatus.NaturalGas} />
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <Assessment1Questions state={state}  fuelType={state.Assessment1FuelTypesStatus.NaturalGas} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.FuelOilFollowup &&
              <div>
                  <p>
                      <strong><u>Step 3c:</u>Results - Fuel Oil Households</strong>
                  </p>
                  
                  <Assessment1TopParagraph state={state}  fuelType={state.Assessment1FuelTypesStatus.FuelOil} />
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <Assessment1Questions state={state}  fuelType={state.Assessment1FuelTypesStatus.FuelOil} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.PropaneFollowup &&
              <div>
                  <p>
                      <strong><u>Step 3d:</u>Results - Propane Households</strong>
                  </p>
                  
                  <Assessment1TopParagraph state={state}  fuelType={state.Assessment1FuelTypesStatus.Propane} />
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <Assessment1Questions state={state}  fuelType={state.Assessment1FuelTypesStatus.Propane} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.ActionPlanSummary &&
              <div>
                  <p>
                      <strong><u>Step 4:</u> Aggregated Action Plan </strong>
                  </p>
                  <p>
                      Congratulations! You have reached the end of Assessment #1. Your aggregated action plan for every issue
                      identified in Assessment #1 is included in the table below. You can now download or print the Assessment
                      #1 action plan below. Also, you can revisit this page at any time by selecting it from the list of completed
                      assessment on the Assessment Tool Selection Page. 
                  </p>
                  <table id="tblDataReliabilityActionPlan">
                      <thead>
                        <tr>
                            <th>Fuel</th>
                            <th>Issue</th>
                            <th>Action Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                      {state.assessment1GetFuelTypesArray().map(fuel => {
                          return (
                              <React.Fragment key={fuel.description}>
                                  {(fuel.IncludingEnergyUseChargesFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Expenditure amounts reported vendors should include energy usage charges</td>
                                    <td>
                                      {fuel.IncludingEnergyUseChargesDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IncludingEnergyDeliveryChargesFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Expenditure amounts reported vendors should include include delivery, fixed charges,
                                        and taxes.</td>
                                    <td>
                                      {fuel.IncludingEnergyDeliveryChargesDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IncludingEnergyOptionalChargesFlag === true)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Expenditure amounts reported by vendors should NOT include optional charges.</td>
                                    <td>
                                      {fuel.IncludingEnergyOptionalChargesDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.Including12MonthOnlyFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors should be reporting for a 12 month period only.</td>
                                    <td>
                                      {fuel.Including12MonthOnlyDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IncludingComplete12MonthFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors should be reporting for a full 12 month period.</td>
                                    <td>
                                      {fuel.IncludingComplete12MonthDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IndicatingLessThan12MonthFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>If a client`s expenditure data represents less than 12-months for any reason, this needs
                                        to be indicated and accounted when calculating your average expenditures.</td>
                                    <td>
                                      {fuel.IndicatingLessThan12MonthDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.ReportingAfterDiscountsFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors should be sending billing data after low-income discounts have been applied.</td>
                                    <td>
                                      {fuel.ReportingAfterDiscountsDesc}
                                    </td>
                                  </tr>}



                                  {(fuel.CheckOutliersFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors check outliers in the data they report to you to ensure that they did not make any errors.</td>
                                    <td>
                                      {fuel.CheckOutliersDesc}
                                    </td>
                                  </tr>}


                                  {(fuel.IncludeOnlyAmountBilledFlag === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors should only include the new amounts that households are billed each month, and not the total amount owed.</td>
                                    <td>
                                      {fuel.IncludeOnlyAmountBilledDesc}
                                    </td>
                                  </tr>}

                                  {(fuel.OtherReasonDesc != '' && fuel.OtherReasonDesc != null)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                        Potential data reliability issue cannot be
                                        explained by the most common reasons</td>
                                    <td>
                                      {fuel.OtherReasonDesc}
                                    </td>
                                  </tr>}

                                  {(fuel.computedAverageExpenditure === 0
                                      && fuel.totalAssistedhHNum>0
                                      && (fuel.ZeroAvgExpenditureDataReasonDesc != '' && fuel.ZeroAvgExpenditureDataReasonDesc != null))
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                        Performance Measures Form indicates that you assisted households that used
                                        {fuel.description} for heating
                                        but did NOT collect and/or report data for any of those households</td>
                                    <td>
                                      {fuel.ZeroAvgExpenditureDataReasonDesc}
                                    </td>
                                  </tr>}
                              </React.Fragment>
                          )
                      })}
                      </tbody>
                  </table>
              </div>
          }
      
          <br />
          
          
          <button className="dataButton"
              onClick={() => state.assessment1ShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment1ShowNextStep()}
                  disabled={state.Assessment1ShowNextStepDisabled === true}>
                  Next
              </button>
          }
          {state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment1ShowActionPlan()}
                  disabled={state.Assessment1ShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }
          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment1StepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>
          {state.CurrentAssessementStepIndex === Assessment1StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.ActionPlanSummary
          &&
            <Assessment1DownloadCSV fuelTypes={[state.Assessment1FuelTypesStatus.NaturalGas, , state.Assessment1FuelTypesStatus.FuelOil, state.Assessment1FuelTypesStatus.Propane]}/>
          }
          <div style={{clear:"both"}}>&nbsp;</div>
      </div>
    );

export default Assessment1;
